"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var PropTypes = require("prop-types");
var React = require("react");
var url_helpers_1 = require("../shared/url_helpers");
var user_store_1 = require("../../reverb-js-common/user_store");
var CollectionHeaderRenameButton = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionHeaderRenameButton, _super);
    function CollectionHeaderRenameButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CollectionHeaderRenameButton, "propTypes", {
        get: function () {
            return {
                slug: PropTypes.string,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionHeaderRenameButton.prototype, "isUserAdmin", {
        get: function () {
            return user_store_1.default.getState().isAdmin;
        },
        enumerable: true,
        configurable: true
    });
    CollectionHeaderRenameButton.prototype.render = function () {
        if (!this.isUserAdmin) {
            return false;
        }
        return (React.createElement("a", { className: "ml-1", href: url_helpers_1.default.adminRenameBrandPath(this.props.slug) }, I18n.t('discovery.collectionHeader.rename')));
    };
    return CollectionHeaderRenameButton;
}(React.Component));
exports.default = CollectionHeaderRenameButton;
//# sourceMappingURL=collection_header_rename_button.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/collection_header_rename_button.js
// module id = DvGg
// module chunks = 20 21